import { Account } from 'Types';

export type AccountData = {
  id: number;
  codeTiers: string;
  siretEDI: string;
  teliway: string;
  teliwayName: string;
  isActive: boolean;
};

export const formatAccountList = (accounts: Account[]): AccountData[] => {
  return accounts
    .map(
      ({
        id,
        codeTiers,
        siretEDI,
        teliwayName,
        isActive,
        agency: {
          teliway: { name },
        },
      }) => ({
        id,
        codeTiers,
        teliway: name,
        siretEDI,
        teliwayName,
        isActive,
      }),
    )
    .filter((account) => !account.codeTiers.startsWith('$'));
};
